export default __webpack_public_path__ + "static/media/sponsor_16.38889e6d.png";